// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.MenuIcon {
  font-size: 20px !important;
  color: gray !important;
  cursor: pointer;
}
.menuIconSelected {
  cursor: pointer;
  font-weight: bold !important;  
  color: green !important;      
}

.terminalButton {
  min-width: 36px !important ;
  height: 55px !important ;
  padding-left: 12x !important ;
  padding-right: 12px !important ;
  border-color: rgba(0, 0, 0, 0.23) !important;
  border-radius: 0px !important;
}

`, "",{"version":3,"sources":["webpack://./src/styles/SelectSourceAndDestination.css"],"names":[],"mappings":";AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,6BAA6B;EAC7B,+BAA+B;EAC/B,4CAA4C;EAC5C,6BAA6B;AAC/B","sourcesContent":["\r\n.MenuIcon {\r\n  font-size: 20px !important;\r\n  color: gray !important;\r\n  cursor: pointer;\r\n}\r\n.menuIconSelected {\r\n  cursor: pointer;\r\n  font-weight: bold !important;  \r\n  color: green !important;      \r\n}\r\n\r\n.terminalButton {\r\n  min-width: 36px !important ;\r\n  height: 55px !important ;\r\n  padding-left: 12x !important ;\r\n  padding-right: 12px !important ;\r\n  border-color: rgba(0, 0, 0, 0.23) !important;\r\n  border-radius: 0px !important;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
